<template>
    <div class="pro">
        <div class="banner">
            <div class="banner-video">  
                <video src="@/assets/img/video/pro.mp4" loop="loop" autoplay="autoplay" x5-video-player-type="h5-page"  x5-video-player-fullscreen="" x5-video-orientation="portraint" class="footer-bg"></video>
            </div>
            <div class="container">
            <div class="banner-text">
              <h2>Technology<br>Service</h2>
              <h3>技术服务</h3>
            </div>
            </div>
        </div>
        <!-- <Prolink />  -->
        <div class="protech container" style="margin-top:30px;">
            <el-row :gutter="20">
                <el-col :span="8"  v-for="tech in techs" :key="tech.index">
                     <div class="box-card tech-card" shadow="hover">
                        <div class="tech-img">
                          <img :src="tech.src">
                        </div>
                        <p class="tech-title">{{tech.title}}</p>
                    </div>
                </el-col>
            </el-row>
        </div>
        
    </div>
</template>
<script>
export default{
    data() {
        return {
           techs: [{
                src: require('../../assets/img/pro/tech_1.png'),
                title: 'SDC/EDC建模与验证服务',
                }, {
                src: require('../../assets/img/pro/tech_2.png'),
                title: 'DCS个性化模板库建设',
                }, {
                src: require('../../assets/img/pro/tech_3.png'),
                title: 'SDC多数据源接入服务',
                },{
                src: require('../../assets/img/pro/tech_4.png'),
                title: 'VMS可视化定制服务',
                },{
                src: require('../../assets/img/pro/tech_5.png'),
                title: '临床研究源数据治理服务',
                },{
                src: require('../../assets/img/pro/tech_6.png'),
                title: 'BPM业务流程定制化服务',
                }
            ],
        };
    },
    components:{
       
    }
}
</script>
<style scoped>
.banner{
  width: 100vw;
  height: 600px;
  z-index: -1;
  position: relative;
}
.banner-video video{
    width: 100%;
    height: 700px;
    margin-top: -100px;
    opacity: 0.9;
    object-fit: cover;
    position: absolute;
    z-index: -9999;
    left: 0px;
}
.container{
  position: relative;
}
.banner-text{
  position: absolute;
  color: #fff;
  left: 100px;
  top: 150px;
}
.banner-text h2{
  font-size: 60px;
  color: rgba(255,255,255,0.3);
  opacity: 0.1;
  text-align: left;
}
.banner-text h3{
  font-size: 36px;
  margin-top: -115px;
  border-top: 1px solid #eee3;
  text-align: left;
  line-height: 80px;
  letter-spacing: 10px;
}
.tech-card{
  background: #38445D;
  margin-bottom: 20px;
  border-radius: 10px;
  border: 1px solid #eee;
}
.tech-card .el-card__body{
  padding: 0px;
}
.tech-img{
  display: flex;
  text-align: center;
  height: 300px;
  justify-content: center; 
	align-items: center; 
}
.tech-img img{
  width: 80%;
  height: auto;
}
.tech-title{
  font-size: 16px;
  background-color: #fff;
  line-height: 50px;
  text-align: center;
  border-radius: 0 0 8px 8px;
}
</style>